/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalIds
 */
export interface ExternalIds {
}

/**
 * Check if a given object implements the ExternalIds interface.
 */
export function instanceOfExternalIds(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalIdsFromJSON(json: any): ExternalIds {
    return ExternalIdsFromJSONTyped(json, false);
}

export function ExternalIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalIds {
    return json;
}

export function ExternalIdsToJSON(value?: ExternalIds | null): any {
    return value;
}

